<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Sending Insurance Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="sending"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				sending: "AegCaseSendingInsurance"
			}
		}
	}
}
</script>
